export default "__VITE_ASSET__a4255929__"